import React, { useState, useEffect } from 'react';
// Cargar descripciones estructuradas en tiempo de ejecución desde /descripciones_estructuradas.json
let descriptionsCache = null;
import ProductReview from './ProductReview';
import ColorSelectionModal from './ColorSelectionModal';
import { reviews } from '../mock/reviews';

const ProductDetail = ({ product, onAddToCart, onClose, colorData }) => {
  const [showColorModal, setShowColorModal] = useState(false);
  const [zoomed, setZoomed] = useState(false);
  const [imgRatio, setImgRatio] = useState(1); // ancho/alto
  const [descLoaded, setDescLoaded] = useState(false);

  // Cargar descripciones una única vez
  useEffect(() => {
    if (!descriptionsCache) {
      fetch(process.env.PUBLIC_URL + '/descripciones_estructuradas.json')
        .then(res => res.json())
        .then(data => {
          descriptionsCache = data;
          setDescLoaded(true); // Forzar re‐render
        })
        .catch(err => console.error('Error cargando descripciones estructuradas:', err));
    }
  }, []);

  if (!product) return null;

  const productReviews = reviews.filter(review => review.productId === product.id);

  // Obtener detalles estructurados: primero revisar si vienen en el objeto, si no, buscar en JSON
  const structuredDetails = product.structured_details || (() => {
    const modeloLimpio = product.name.replace(/ DS$/, '').trim().toLowerCase();
    const match = descriptionsCache ? descriptionsCache.find(entry => entry.modelo.toLowerCase() === modeloLimpio) : null;
    return match ? match : null;
  })();
  const averageRating = productReviews.length > 0 
    ? (productReviews.reduce((sum, review) => sum + review.rating, 0) / productReviews.length).toFixed(1)
    : 'N/A';

  const handleAddToCartWithColor = (productWithColor) => {
    onAddToCart(productWithColor);
  };

  const supabaseStorageUrl = "https://xsuruuynxrxrarvalzjb.supabase.co/storage/v1/object/public/images/";

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto flex flex-col md:flex-row relative">
          <div
            className="p-6 md:w-1/2 flex items-center justify-center bg-white rounded-l-xl"
            style={{ height: `min(80vw / ${imgRatio}, 80vh)` }}
          >
            {product.image ? (
              <div className="overflow-hidden rounded-lg relative group w-full h-full flex items-center justify-center bg-white shadow-2xl">
                <img
                  src={product.image ? (supabaseStorageUrl + product.image) : (supabaseStorageUrl + 'blank.jpg')}
                  alt={product.name}
                  className="w-full h-full object-contain object-center transition-transform duration-300 ease-in-out"
                  style={{ transitionProperty: 'transform, box-shadow' }}
                  onLoad={e => {
                    const { naturalWidth, naturalHeight } = e.target;
                    setImgRatio(naturalWidth / naturalHeight || 1);
                  }}
                  onError={e => {
                    if (!e.target.src.includes('blank.jpg')) {
                      e.target.onerror = null;
                      e.target.src = supabaseStorageUrl + 'blank.jpg';
                    }
                  }}
                />
              </div>
            ) : null}
          </div>

          <div className="p-6 md:w-1/2 relative">
            <button 
              onClick={onClose} 
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 p-1 rounded-full transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <h2 className="text-3xl font-bold text-gray-900 mb-2">{product.name.replace(/ DS$/, '')}</h2>
            <p className="text-gray-600 text-sm mb-4">{product.category} | {product.brand}</p>
            
            <p className="text-gray-700 mb-6">{product.description}</p>
            <div className="mb-6">
              <p className="text-4xl font-bold text-gray-900">
                ${product.pricears ? product.pricears.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : 'Sin precio'}
              </p>
              {product.price && (
                <p className="text-lg font-medium text-green-600 mt-2">
                  USD ${typeof product.price === 'string' ? product.price : product.price.toLocaleString('en-US')}
                </p>
              )}
            </div>

            {/* Especificaciones Estructuradas */}
            {structuredDetails && (
              <div className="mb-6 bg-gray-50 rounded-lg p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Especificaciones</h3>
                <div className="grid grid-cols-1 gap-1">
                  {(structuredDetails.detalles ? Object.entries(structuredDetails.detalles) : Object.entries(structuredDetails)).map(([key, value]) => (
                    <div key={key} className="flex items-center gap-2 text-sm py-0.5">
                      <span className="text-lg">{key.split(' ')[0]}</span>
                      <span className="text-gray-600">{value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Botón de agregar al carrito */}
                <button 
                  onClick={() => setShowColorModal(true)}
              className="relative w-full py-3 bg-gray-100 text-gray-700 rounded-full text-lg font-medium transition-all duration-150 hover:bg-gray-200 active:transform active:scale-95 active:shadow-inner focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50 shadow-sm hover:shadow-md"
              style={{ boxShadow: 'inset 2px 2px 8px #bbb, inset -2px -2px 8px #fff' }}
            >
              Agregar al Carrito
                </button>

                {showColorModal && (
                  <ColorSelectionModal
                    product={product}
                    onClose={() => setShowColorModal(false)}
                    onAddToCart={handleAddToCartWithColor}
                  />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetail;